var map = {
	"./dailymotion.svg": [
		87328,
		328
	],
	"./default_platform.svg": [
		80784,
		784
	],
	"./douyin.svg": [
		7119,
		119
	],
	"./facebook.svg": [
		79711,
		711
	],
	"./facebook_ads.svg": [
		37016,
		16
	],
	"./fiverr.svg": [
		50923,
		923
	],
	"./imgur.svg": [
		12501,
		501
	],
	"./instagram.svg": [
		69077,
		77
	],
	"./instagram_ads.png": [
		85552,
		552
	],
	"./kakao_talk.svg": [
		74007,
		7
	],
	"./linkedin.svg": [
		1001,
		1
	],
	"./naver_blog.svg": [
		71774,
		774
	],
	"./onlyfans.svg": [
		28935,
		935
	],
	"./patreon.svg": [
		56490,
		490
	],
	"./pinterest.svg": [
		45583,
		583
	],
	"./qq.svg": [
		22249,
		249
	],
	"./reddit.svg": [
		43155,
		155
	],
	"./telegram.svg": [
		7718,
		718
	],
	"./tiktok.svg": [
		205,
		205
	],
	"./twitch.svg": [
		5314,
		314
	],
	"./twitter.svg": [
		21464,
		464
	],
	"./vk.svg": [
		25886,
		886
	],
	"./wechat.svg": [
		43857,
		857
	],
	"./weibo.svg": [
		46653,
		653
	],
	"./whatsapp.svg": [
		57081,
		81
	],
	"./x.svg": [
		78929,
		929
	],
	"./xiaohongshu.svg": [
		20522,
		522
	],
	"./youtube.svg": [
		64734,
		734
	],
	"./yupoo.svg": [
		86665,
		665
	],
	"./zhihu.svg": [
		45775,
		775
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94471;
module.exports = webpackAsyncContext;